import axios from "axios";
import settings from "../settings";
import router from "../router";

const et = {
    weekDays: ["Esmaspäev", "Teisipäev", "Kolmapäev", "Neljapäev", "Reede", "Laupäev", "Pühapäev"],
    weekDaysShort: ["E", "T", "K", "N", "R", "L", "P"],
    months: [
        "Jaanuar",
        "Veebruar",
        "Märts",
        "Aprill",
        "Mai",
        "Juuni",
        "Juuli",
        "August",
        "September",
        "Oktoober",
        "November",
        "Detsember",
    ],
    years: "Aastad",
    year: "Aasta",
    month: "Kuu",
    week: "Nädal",
    day: "Päev",
    today: "Täna",
    noEvent: "Sündmusi pole",
    allDay: "Kogu päev",
    deleteEvent: "Kustuta sündmus",
    createEvent: "Loo sündmus",
    dateFormat: "YYYY MMMM D dddd",
};

const sizeOptions = {
    incoming: [
        {id: "truck_33_pallets", text: "Truck 33 pallets", value: 60},
        {id: "truck_20_pallets", text: "Truck 20 pallets", value: 30},
        {
            id: "20_foot_container_without_pallets",
            text: "20-foot container without pallets",
            value: 240,
        },
        {
            id: "40_foot_container_without_pallets",
            text: "40-foot container without pallets",
            value: 300,
        },
        {
            id: "20_foot_reefer_container_without_pallets",
            text: "20-foot reefer container without pallets",
            value: 240,
        },
        {
            id: "40_foot_reefer_container_without_pallets",
            text: "40-foot reefer container without pallets",
            value: 300,
        },
        {
            id: "20_foot_container_with_pallets",
            text: "20-foot container with pallets",
            value: 60,
        },
        {
            id: "40_foot_container_with_pallets",
            text: "40-foot container with pallets",
            value: 120,
        },
        {
            id: "20_foot_reefer_container_with_pallets",
            text: "20-foot reefer container with pallets",
            value: 60,
        },
        {
            id: "40_foot_reefer_container_with_pallets",
            text: "40-foot reefer container with pallets",
            value: 120,
        },
        {id: "1_19_pallets", text: "1-19 pallets", value: 15},
    ],
    outgoing: [
        {id: "truck_33_pallets", text: "Truck 33 pallets", value: 45},
        {id: "truck_20_pallets", text: "Truck 20 pallets", value: 25},
        {
            id: "20_foot_container_without_pallets",
            text: "20-foot container without pallets",
            value: 240,
        },
        {
            id: "40_foot_container_without_pallets",
            text: "40-foot container without pallets",
            value: 480,
        },
        {
            id: "20_foot_reefer_container_without_pallets",
            text: "20-foot reefer container without pallets",
            value: 240,
        },
        {
            id: "40_foot_reefer_container_without_pallets",
            text: "40-foot reefer container without pallets",
            value: 480,
        },
        {
            id: "20_foot_container_with_pallets",
            text: "20-foot container with pallets",
            value: 60,
        },
        {
            id: "40_foot_container_with_pallets",
            text: "40-foot container with pallets",
            value: 120,
        },
        {
            id: "20_foot_reefer_container_with_pallets",
            text: "20-foot reefer container with pallets",
            value: 60,
        },
        {
            id: "40_foot_reefer_container_with_pallets",
            text: "40-foot reefer container with pallets",
            value: 120,
        },
        {id: "1_19_pallets", text: "1-19 pallets", value: 15},
    ],
};

let initialState = {
    loadingShipmentList: false,
    loadingShipmentData: false,
    requestSuccess: false,
    requestError: false,
    drawerOpen: false,
    activeShipment: {},
    createdEvent: null,
    shipments: {
        incoming: [],
        outgoing: [],
    },
    pendingShipments: {
        incoming: [],
        outgoing: [],
    },
    shipmentCompanies: [],
    searchShipmentString: "",
    errorMessage: "",
    sizes: sizeOptions,
    vuecalLocale: et,
    generateLinkDialog: false,
    loadingGenerateLinkSubmit: false,
};

export default {
    namespaced: true,
    state: {...initialState},
    actions: {
        async getShipmentList({commit}, search = null) {
            commit("setShipmentListLoading", true);
            try {
                let response = await axios.get(settings.api_url + "/shipments/", {params: search});
                if (response.status === 200) {
                    let data = response.data;
                    commit("setShipments", data.shipments);
                    commit("setPendingShipments", data.pending);
                    commit("setShipmentListLoading", false);
                }
            } catch (e) {
                console.log(e);
                commit("setShipmentListLoading", false);
            }
        },
        async getShipmentData({commit}, shipmentId) {
            commit("setShipmentDataLoading", true);
            try {
                let response = await axios.get(settings.api_url + "/shipment/" + shipmentId);
                if (response && response.data) {
                    let data = response.data;
                    commit("setActiveShipment", data);
                }
                commit("setShipmentDataLoading", false);
            } catch (e) {
                console.log(e);
                commit("setShipmentDataLoading", false);
            }
        },
        async submitShipmentUpdate({commit, dispatch}, payload) {
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            commit("setErrorMessage", "");

            try {
                const response = await axios.post(settings.api_url + "/shipment/", payload);

                if (response.status === 200 && response.data.success === 1) {
                    commit("setRequestSuccess", true);
                    dispatch("getShipmentList");

                    return response.data.shipment_id;
                } else {
                    commit("setRequestError", true);
                    if (response.data.error === "timeslot_unavailable") {
                        commit("setErrorMessage", "Timeslot is unavailable, please pick another");
                    }
                    return null;
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                return null;
            }
        },
        async toggleStatus({state, commit, dispatch}, {shipmentId = null, fetchItemData = false}) {
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            commit("setErrorMessage", "");

            try {
                const response = await axios.put(settings.api_url + "/shipment/" + shipmentId);

                if (response.status === 200 && response.data.success === 1) {
                    commit("setRequestSuccess", true);
                    if (fetchItemData) dispatch("getShipmentData", shipmentId);
                    dispatch("getShipmentList");
                    return response.data.shipment_id;
                } else {
                    commit("setRequestError", true);
                    return null;
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                return null;
            }
        },
        async deleteShipment({commit, dispatch}, {shipmentId}) {
            await commit("setRequestSuccess", false);
            await commit("setErrorMessage", "");
            await commit("setShipmentListLoading", true);
            try {
                let response = await axios.delete(settings.api_url + "/shipment/", {
                    params: {shipment_id: shipmentId},
                });
                if (response && response.data.success === 1) {
                    await dispatch("getShipmentList");
                    await commit("setRequestSuccess", true);
                } else if (response.data.success === 0) {
                    await commit("setRequestError", true);
                    await commit("setErrorMessage", "Failed");
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                commit("setErrorMessage", "Failed");
            }
            commit("setShipmentListLoading", false);
            await router.push("/shipments");
        },
        async submitGenerateLink({commit, dispatch}, payload) {
            commit("setRequestSuccess", false);
            commit("setRequestError", false);
            commit("setErrorMessage", "");
            commit("setLoadingGenerateLinkSubmit", true);

            try {
                const response = await axios.post(settings.api_url + "/shipment-links/", payload);

                if (response.status === 200 && response.data.success === 1) {
                    commit("setRequestSuccess", true);
                    dispatch("getShipmentList");
                    return response.data.url;
                } else {
                    commit("setRequestError", true);
                    return false;
                }
            } catch (e) {
                console.log(e);
                commit("setRequestError", true);
                return null;
            } finally {
                commit("setLoadingGenerateLinkSubmit", false);
            }
        },
        async fetchShipmentCompanyOptions({state, commit}) {
            try {
                let response = await axios.get(settings.api_url + "/shipment-companies/");
                if (response.status === 200) {
                    let data = response.data;
                    commit("setShipmentCompanies", data.companies);
                }
            } catch (e) {
                console.log(e);
            }
        },
    },
    mutations: {
        setRequestSuccess(state, bool) {
            state.requestSuccess = bool;
        },
        setRequestError(state, bool) {
            state.requestError = bool;
        },
        setErrorMessage(state, message) {
            state.errorMessage = message;
        },
        setShipments(state, shipments) {
            state.shipments = shipments;
        },
        setShipmentCompanies(state, companies) {
            state.shipmentCompanies = companies;
        },
        setPendingShipments(state, pendingShipments) {
            state.pendingShipments = pendingShipments;
        },
        setActiveShipment(state, shipment) {
            state.activeShipment = {...shipment};
        },
        toggleDrawer(state, isOpen) {
            state.drawerOpen = isOpen;
        },
        resetActiveShipment(state) {
            state.activeShipment = {};
        },
        addNewShipment(state) {
            state.activeShipment = {};
        },
        setShipmentSearch(state, payload) {
            state.searchShipmentString = payload.term;
            this.dispatch("ShipmentStore/getShipmentList", {
                search: state.searchShipmentString,
            });
        },
        resetShipmentSearch(state) {
            state.searchShipmentString = "";
        },
        setShipmentListLoading(state, value) {
            state.loadingShipmentList = value;
        },
        setShipmentDataLoading(state, value) {
            state.loadingShipmentData = value;
        },
        updateActiveShipmentProperty(state, {prop, value}) {
            state.activeShipment = {
                ...state.activeShipment,
                [prop]: value,
            };
        },
        setCreatedEvent(state, event) {
            state.createdEvent = event;
        },
        setGenerateLinkDialog(state, bool) {
            state.generateLinkDialog = bool;
        },
        setLoadingGenerateLinkSubmit(state, bool) {
            state.loadingGenerateLinkSubmit = bool;
        },
    },
};
